module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topArea pb-5"
  }, [_c('div', {
    staticClass: "text-center darker mt-5 fs-giant"
  }, [_vm._v(_vm._s(_vm.welcomeMessage))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 d-flex justify-content-center mt-3",
    class: {
      'locked': _vm.locked
    }
  }, _vm._l((_vm.filterButtons), function(button) {
    return _c('button', {
      staticClass: "btnFilter pointer border-0 dark fs-small py-1 px-3 bold",
      class: {
        active: _vm.feedFilter == button.term && _vm.locked == false
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.filterChanged(button.term)
        }
      }
    }, [_c('i', {
      staticClass: "color-1 fs-small",
      class: button.icon
    }), _vm._v("\n      " + _vm._s(button.label) + "\n    ")])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-8876cbd4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8876cbd4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/FeedTop.vue
// module id = 2399
// module chunks = 0